import FAQItem from "../../components/questions/Questions";
import styles from "../../screens/ForthScreen.module.css";

const ForthScreen = () => {
  return <>
    <div className={styles.title}>שאלות<div className={styles.titleHighlight}> תשובות</div></div>
    <div className={styles.description}>לפני שנדבר - כל התשובות לשאלות שבטוח עלו לכם לראש, לחצו על כל שאלה והתשובה תיפתח</div>

    <FAQItem
      question="למה לי לקחת ניהול אם יש מדריכים בחינם?"
      answer="בממוצע, בעלות עסקים משקיעות כ-15-20 שעות שבועיות רק על ניסיונות שיווק שלא תמיד עובדים. זמן = כסף. במקום להתברבר עם עריכות, תתמקדי במה שאת הכי טובה בו, פיתוח העסק ושירות לקוחות. אני אדאג להוציא את המקצוענות שלך החוצה בצורה עקבית ומקצועית."
    />

    <FAQItem
      question="מה אם אין לך ניסיון ספציפי בתחום שלי?"
      answer="אני לא צריכה להיות המומחית בתחום שלך, את המומחית! התפקיד שלי הוא להיות המומחית בשיווק. בדיוק כמו שמעצבת פנים לא צריכה להבין בשיפוצים כדי לעצב בית חלומות, אני לוקחת את הזהב שיש לך בידיים והופכת אותו לסיפור שיווקי שפשוט מוכר."
    />

    <FAQItem
      question="כמה זמן ייקח עד שאראה תוצאות?"
      answer="בואי נדבר אמת: שיווק הוא תהליך של בניית אמון וקהילה. בדרך כלל, אחרי שלושה חודשי עבודה עקביים אנחנו כבר רואות שינוי משמעותי באינטראקציה ובפניות. מי שמבטיחה לך &quot;אלפי לקוחות בשבוע&quot; כנראה מוכרת לך אשליות. אני מוכרת לך דרך בטוחה וצמיחה אמיתית."
    />

    <FAQItem
      question="ואם אני ממש לא אוהבת להצטלם?"
      answer="את לא חייבת להיות &quot;דוגמנית הבית&quot; כדי להצליח. יש המון דרכים יצירתיות להעביר את המסרים שלך גם בלי לעמוד שעות מול המצלמה. אפילו אפשר להביא פרזנטורית, הכל טוב. נעבוד בקצב שלך, עם הכלים שנוחים לך, ונדאג שהעסק שלך יקבל את הבמה שמגיעה לו בלי שתסבלי בדרך."
    />

    <FAQItem
      question="כמה זה עולה לי?"
      answer="חשוב לי שתביני שאני לא מאמינה בחבילות &quot;מוצר מדף&quot; שמתאימות לכולן. העסק שלך הוא עולם ומלואו, והצרכים שלך שונים מאלו של עסק אחר. בדיוק בגלל זה, בניתי מגוון מסלולים ותהליכים שיווקיים שמתאימים לשלבים שונים של צמיחה. אחרי שנשוחח, אבין לעומק את המטרות שלך ואראה איפה העסק שלך עומד היום, אכין עבורך הצעה מדויקת ומותאמת אישית למה שאת באמת צריכה כדי לפרוץ."
    />

    <FAQItem
      question="ומה לגבי קמפיין ממומן?"
      answer="אני מאמינה בניהול כספים חכם. המטרה שלנו היא להגדיל את הקהל שלך, אבל אנחנו לא מוציאות שקל על ממומן לפני שהעמוד שלך עבר אופטימיזציה מלאה. רק אחרי שהעמוד שלך &quot;מבושל&quot;, מעביר מסע לקוח מדויק ומתחיל למגנט לידים אורגניים נשלב תקציב פרסום למטא בשיתוף פעולה עם קמפיינר תותח שנתאים בדיוק לצרכים שלך. למה? כי אני לא מוכנה שתזרקי כסף על עמוד שלא יודע למכור. קודם מסדרים את הבית, אחר כך מזמינים אורחים."
    />

    <FAQItem
      question="אני פשוט משלמת לך ואת עושה הכל?"
      answer="הלוואי, אבל שיווק אמיתי הוא עבודת צוות. את מכירה את הלקוחות והסיפורים הכי טוב? אני הצינור שמעביר את כל הזהב הזה לתוכן מנצח. נדרש ממך שיתוף פעולה מסוים כדי שהתוצאה תהיה הכי אותנטית ומדויקת לעסק שלך."
    />

    <FAQItem
      question="כבר עבדתי עם מישהי אחרת וזה לא עבד, למה שאצלך זה יהיה שונה?"
      answer="כי אצלי אין &quot;להעלות פוסט כי צריך&quot;. אנחנו מתחילות מאסטרטגיה ברורה, מטרות מוגדרות וקשר אישי רציף בווטסאפ. עם ניסיון של מעל 5 שנים, אני יודעת ששיווק בלי &quot;אבא ואמא&quot; לא מחזיק. אני כאן כדי להיות השותפה שלך לדרך, עם עין לפרטים ויחס אישי באמת."
    />

    <FAQItem
      question="מה זה בעצם תהליך של ניהול סושיאל מלא?"
      answer="זו המעטפת הכי יוקרתית ומקיפה שלי. היא כוללת הכל: מאסטרטגיה מדויקת, דרך ימי צילום ועריכה מקצועית, ועד ניהול תגובות, אוטומציות וליווי צמוד. זו החבילה המושלמת למי שרוצה שקט נפשי ושיווק שמתקתק ברמה הכי גבוהה שיש."
    />

    <FAQItem
      question="את עובדת עם כל סוגי העסקים?"
      answer="אני עובדת עם מגוון תחומים, אבל הכי חשוב לי ה&quot;קליק&quot;. אני מחפשת בעלות עסקים שמוכנות לעבוד יד ביד, שמעריכות איכות ולא מחפשות קיצורי דרך. אם את מבינה ששיווק הוא השקעה ולא הוצאה, אנחנו כנראה התאמה מושלמת."
    />
  </>
};

export default ForthScreen;
